import PropTypes from "prop-types";

export default function HeaderIndicator({ live }) {
  return (
    <div
      className={`common-header--status ${
        live
          ? "common-header--status-on"
          : "common-header--status-complete"
      }`}
    >
      {live ? "It`s on" : "Complete"}
    </div>
  );
}

HeaderIndicator.propTypes = {
  live: PropTypes.bool,
};

HeaderIndicator.defaultProps = {
  live: true,
};
